module.exports = __webpack_public_path__ + "static/vital-4e70bccb752605478f896954795d93c7.jpg";